import HouseType from '../houseType';
import RoomObject from '../room';
export default class Two extends HouseType {
  constructor() {
    super();
    this.id = 'two';
    this.name = "Tomannsbolig";
    this.icon = "mdi-home-floor-2";
    
    this.defaultRooms = [
      new RoomObject('Entry'),
      new RoomObject('Livingroom'),
      new RoomObject('Kitchen'),
      new RoomObject('Bathroom'),
      new RoomObject('Bedroom'),
      new RoomObject('Bedroom'),
      new RoomObject('Outside')
    ];
  }
}